// Colonnes d'une barre, en tenant compte du redimensionnement en cours sur cette ligne.
export function previewIndexes(sg, match, timelineResize, days) {
  const [field, value] = Object.entries(match)[0];
  let sIdx = sg.sIdx,
    eIdx = sg.eIdx;
  if (
    timelineResize?.[field] === value &&
    sg.affIds.includes(timelineResize.affId) &&
    timelineResize.currentIso
  ) {
    const cIdx = days.findIndex((d) => d.iso === timelineResize.currentIso);
    if (cIdx >= 0) {
      if (timelineResize.edge === 'left') sIdx = Math.min(cIdx, eIdx);
      else eIdx = Math.max(cIdx, sIdx);
    }
  }
  return { sIdx, eIdx };
}
